export class SensorMarker {
  public text!: string;
  public warning!: boolean;
  public critical!: boolean;
  public inactive!: boolean;
  public nodata!: boolean;
  public sensorID!: number;
  public x!: number;
  public y!: number;
  public hidden!: boolean;
  public selected!: boolean;
}
